import { createStore } from 'src/utils/analytics/queueIdb';

// [TODO]: VERIFY THE RETENTION CONFIG
export const retentionConfig = { maxNumber: 250, batchEvictionNumber: 100 };
export const withStore = createStore('analytics', 'accessedRecords', 'key');
export * from 'src/utils/analytics/queueIdb';
export * from '../observables';
